import React from 'react';
import { Link } from '@tanstack/react-router';

type BreadcrumbItem = {
  title: string;
  url: string;
  isHome?: boolean;
  isCurrent?: boolean;
};

type BreadcrumbProps = {
  items: BreadcrumbItem[];
};

const HomeIcon: React.FC = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="l-breadcrumbItem__icon"
  >
    <path
      d="M15.9944 8.09722C15.9944 8.59722 15.5777 8.98889 15.1055 8.98889H14.2166L14.236 13.4389C14.236 13.5139 14.2305 13.5889 14.2221 13.6639V14.1139C14.2221 14.7278 13.7249 15.225 13.111 15.225H12.6666C12.636 15.225 12.6055 15.225 12.5749 15.2222C12.536 15.225 12.4971 15.225 12.4582 15.225L11.5555 15.2222H10.8888C10.2749 15.2222 9.77769 14.725 9.77769 14.1111V13.4444V11.6667C9.77769 11.175 9.38046 10.7778 8.8888 10.7778H7.11102C6.61935 10.7778 6.22213 11.175 6.22213 11.6667V13.4444V14.1111C6.22213 14.725 5.72491 15.2222 5.11102 15.2222H4.44435H3.55824C3.51657 15.2222 3.47491 15.2194 3.43324 15.2167C3.39991 15.2194 3.36657 15.2222 3.33324 15.2222H2.8888C2.27491 15.2222 1.77769 14.725 1.77769 14.1111V11C1.77769 10.975 1.77769 10.9472 1.78046 10.9222V8.98611H0.891574C0.391574 8.98611 0.00268555 8.59722 0.00268555 8.09444C0.00268555 7.84444 0.0860189 7.62222 0.280463 7.42778L7.39991 1.22222C7.59435 1.02778 7.81657 1 8.01102 1C8.20546 1 8.42768 1.05556 8.59435 1.19444L15.6888 7.43056C15.911 7.625 16.0221 7.84722 15.9944 8.09722Z"
      fill="currentColor"
    />
  </svg>
);

const BreadcrumbItem: React.FC<{ item: BreadcrumbItem }> = ({ item }) => {
  const currentClass = item.isCurrent ? 'isCurrent' : '';

  // タイトルを40文字で省略
  const displayTitle =
    item.isCurrent && item.title.length > 40 ? `${item.title.substring(0, 40)}...` : item.title;

  if (item.isHome) {
    return (
      <li className={`l-breadcrumbItem ${currentClass}`}>
        {item.isCurrent ? (
          <span className="l-breadcrumbItem__link">
            <HomeIcon />
          </span>
        ) : (
          <Link className="l-breadcrumbItem__link" to={item.url}>
            <HomeIcon />
          </Link>
        )}
      </li>
    );
  }

  return (
    <li className={`l-breadcrumbItem ${currentClass}`}>
      {item.isCurrent ? (
        <span title={item.title}>{displayTitle}</span>
      ) : (
        <Link className="l-breadcrumbItem__link" to={item.url}>
          {item.title}
        </Link>
      )}
    </li>
  );
};

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  return (
    <ol className="l-breadcrumb">
      {items.map((item, index) => (
        <BreadcrumbItem key={index} item={item} />
      ))}
    </ol>
  );
};

export default Breadcrumb;
export type { BreadcrumbItem };
